module.exports = __webpack_public_path__ + "img/right-branch.b686e158.png";